// Checks every field-name/casing variant of "guest" seen across this app's
// auth responses so far — the JWT payload itself uses `role`/`userType`
// (camelCase), while the documented /auth/login response shape uses
// `user_type` (snake_case). Guards against the guest flow silently breaking
// (e.g. falling back to normal-login behavior) if the backend's user object
// doesn't exactly match whichever single field name a caller assumed.
//
// Lives in its own dependency-free module (rather than only in AuthContext,
// which it's still re-exported from for existing callers) so api/axios.js
// can use it too without a circular import — AuthContext already imports
// the axios instance.
export const isGuestUser = (user) =>
  user?.user_type === "G" || user?.userType === "G" || user?.role === "G";
